import LoadingSpinner from './LoadingSpinner';
import EmptyState from './EmptyState';

export default function Table({
    columns,
    data,
    loading = false,
    emptyState,
    onRowClick,
}) {
    if (loading) {
        return (
            <div className="py-12">
                <LoadingSpinner size="large" />
            </div>
        );
    }

    if (!data || data.length === 0) {
        if (emptyState) {
            return <EmptyState {...emptyState} />;
        }
        return <EmptyState title="No data" description="No items to display" />;
    }

    return (
        <div className="overflow-x-auto">
            <table className="table">
                <thead>
                    <tr>
                        {columns.map((column, index) => (
                            <th key={index} className={column.headerClassName}>
                                {column.header}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {data.map((row, rowIndex) => (
                        <tr
                            key={row.id || rowIndex}
                            onClick={onRowClick ? () => onRowClick(row) : undefined}
                            className={onRowClick ? 'cursor-pointer' : ''}
                        >
                            {columns.map((column, colIndex) => (
                                <td key={colIndex} className={column.cellClassName}>
                                    {column.render ? column.render(row) : row[column.accessor]}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

